import { useState, useCallback } from "react";
import { ConfirmDialog } from "./ConfirmDialog";
import { Input } from "./primitives";

export interface ConfirmDeleteDialogProps {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void | Promise<void>;
  loading?: boolean;
  title: string;
  description: string;
  confirmMatchText: string;
  confirmLabel?: string;
}

export function ConfirmDeleteDialog({
  open,
  onClose,
  onConfirm,
  loading = false,
  title,
  description,
  confirmMatchText,
  confirmLabel = "Delete",
}: ConfirmDeleteDialogProps) {
  const [typedValue, setTypedValue] = useState("");

  const handleClose = useCallback(() => {
    setTypedValue("");
    onClose();
  }, [onClose]);

  const isMatch = typedValue === confirmMatchText;

  return (
    <ConfirmDialog open={open} onClose={handleClose}>
      <ConfirmDialog.Title>{title}</ConfirmDialog.Title>
      <ConfirmDialog.Body>
        <div className="space-y-4">
          <p>{description}</p>
          <div>
            <p className="text-[13px] text-secondary mb-2">
              Type <strong className="text-primary">{confirmMatchText}</strong>{" "}
              to confirm
            </p>
            <Input
              value={typedValue}
              onChange={(e) => setTypedValue(e.target.value)}
              placeholder={confirmMatchText}
              autoComplete="off"
              autoFocus
            />
          </div>
        </div>
      </ConfirmDialog.Body>
      <ConfirmDialog.Actions
        onConfirm={onConfirm}
        onCancel={handleClose}
        confirmLabel={confirmLabel}
        variant="danger"
        loading={loading}
        confirmDisabled={!isMatch}
      />
    </ConfirmDialog>
  );
}
